module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <!-- Global navbar for the app -->\n  <navbar></navbar>\n  <!-- Main view file -->\n  <div id=\"main-view\" ui-view></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 659
// module chunks = 0